import EventEmitter from './eventEmiter';

export const logoutSession = () => {
  EventEmitter.emit('logoutSession', true);
};
export const resetLogoutSession = () => {
  EventEmitter.emit('logoutSession', false);
};
